import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { api_routes } from '@app/consts';
import { TranslateService } from '@ngx-translate/core';
import { GridDataResult } from '@progress/kendo-angular-grid';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { EnvironmentService } from '@app/core/services/environment.service';
import { PagedData } from '@app/modules/lookup/models/paged-data.model';
import { GoalsReportItem } from '../models/goals-report.model';


const headers = new HttpHeaders({
    'Content-Type': 'application/json',
});

@Injectable({
    providedIn: 'root'
})
export class GoalsReportService {

    private readonly activeEmployeeFilter = '(employee.status.id = "Active")';

    constructor(
        private http: HttpClient,
        private translate: TranslateService,
        private envService: EnvironmentService
    ) {
    }

    public fetch(take: number, skip: number, filterString?: string, sortString?: string, filterInactive?: boolean): Observable<PagedData<GoalsReportItem>> {

        const combinedFilter = filterInactive
            ? filterString
                ? `(${filterString}) and ${this.activeEmployeeFilter}`
                : this.activeEmployeeFilter
            : filterString;

        let params = new HttpParams();
        take ? params = params.append('take', take) : null;
        skip ? params = params.append('skip', skip) : null;
        combinedFilter ? params = params.append('Filter', combinedFilter) : null;
        sortString ? params = params.append('Sort', sortString) : null;

        return this.http.get<PagedData<GoalsReportItem>>(`${this.envService.env.apiUrl}${api_routes.REPORTS}/${api_routes.PREDEFINED}/${api_routes.GOALS_REPORT}`,
            {
                headers,
                params,
            });
    }

    async getAllData(sort?: string, filter?: string, filterInactive?: boolean): Promise<PagedData<GoalsReportItem>> {
        
        
        let take = 100;
        let skip = 0;
        let allData = {
            skip: null,
            take: null,
            totalPages: null,
            total: null,
            data: []
        }

        while (allData.total === null || skip < allData.total) {
            const res = await this.fetch(take, skip, filter, sort, filterInactive).toPromise();

            if (res && res.data && res.data.length > 0) {
                allData.data = allData.data.concat(res.data);
                skip += take;
                allData.total = res.total;
            } else {
                break;
            }
        }

        return allData;
    }

}
